import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";

export default function Team() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/sales/team").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="sales-team">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-black">Sales team</h1>
        <p className="text-muted-foreground">Executives, monthly performance, assigned leads and completed visits.</p>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>Executive</TableHead><TableHead>Role</TableHead><TableHead>Month revenue</TableHead><TableHead>Month orders</TableHead><TableHead>Leads assigned</TableHead><TableHead>Visits done</TableHead></TableRow></TableHeader>
          <TableBody>
            {items.map((u) => (
              <TableRow key={u.id} data-testid={`team-row-${u.id}`}>
                <TableCell><div className="font-semibold">{u.full_name}</div><div className="text-xs text-muted-foreground">{u.email}</div></TableCell>
                <TableCell><Badge variant="outline" className="font-mono text-[10px]">{u.role}</Badge></TableCell>
                <TableCell>₹{u.month_revenue.toLocaleString()}</TableCell>
                <TableCell>{u.month_orders}</TableCell>
                <TableCell>{u.leads_assigned}</TableCell>
                <TableCell>{u.completed_visits}</TableCell>
              </TableRow>
            ))}
            {items.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-muted-foreground py-10">No executives in your team yet.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
      <Card><CardContent className="p-4 text-sm text-muted-foreground">Tip: assign leads from the <strong>Leads</strong> page; set monthly targets under <strong>Targets</strong>.</CardContent></Card>
    </div>
  );
}
